import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, List, SatelliteIcon } from "lucide-react";
import MapComponent from "../components/MapComponent";
import {MapComponentWMS} from "../components/MapComponentWMS"
//import poiDataJSON from "./data/point.json";
import config from "./config";
import logo from './data/logoch.png';
import logoa from './data/logoa.png';
import ImageSlider from "./imgslider";
import MHeader from "./header";
import Mfooter from "./footer";
const Button = ({ children, onClick }) => (
  <button
  onClick={onClick}
  className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
  >
    {children}
  </button>
);


export default function App() {
  const [poiData, setPoiData] = useState([]);
  const [view, setView] = useState("map");
  const cardColors = ["card-blue", "card-green", "card-yellow", "card-pink", "card-purple"];  
  const navigate = useNavigate();
  useEffect(() => {
     navigate("/login");
     fetch(config.apiUrl+"/getpoi")
      .then((res) => res.json())
      .then((data) => setPoiData(data))
      .catch((error) => console.error("Errore nel fetch dei comuni:", error));
  
     //setPoiData(poiDataJSON);
  }, []);

  return (
    <div className="p-4 pb-[520px]">
      <div className="flex justify-between items-center mb-4" >
        <h1 className="text-2xl font-bold"></h1>
        <MHeader/>
        
        <table  border="0">
        <tr>
            <td>
                
                <Button onClick={() => setView("map")}><MapPin className="mr-2" /><br/>Mappa</Button> 
            </td>
            <td>
               <Button onClick={() => setView("list")}><List className="mr-2" /><br/>Lista</Button>
                
            </td>
            {/* <td>
               <Button onClick={() => setView("gis")}><SatelliteIcon className="mr-2" /><br/>GIS</Button>
                
            </td>
            */}
    </tr>

    </table>
      </div>

      {view === "map" ? (
        <MapComponent poiData={poiData} />
        // <MapComponentWMS />
      ) : (view ==="list"? (
        <ul className="space-y-4">
          {poiData.map((poi, idx) => (
          <div key={idx} className={`card ${cardColors[idx % 2]}`}>
              <div className="card-left">
                <ImageSlider poi={poi} />

              </div>
              <div className="card-left">
                <h2><a href={poi.link} target="_blank" rel="noopener noreferrer">{poi.nome}</a></h2>
                <p>{poi.ldescrizione}</p>
                <p className="address">{poi.indirizzo}</p>
              </div>
              <div className="card-right">
              {poi.layers && poi.layers.length > 0 && (
                <div>
                  {/* <h3>Risorse Gis:</h3><br/>
                  <ul>
                    {poi.layers.map((layer, i) => (
                      <li key={i}><a href={layer.link} target="_blank" rel="noopener noreferrer">{layer.nome}</a></li>
                    ))}
                  </ul>
                  */}
                  
                </div>
              )}
              {poi.bimobj && poi.bimobj.length >0 &&(
                  <div>
                      <h3><a rel="noopener noreferrer" href ={"/objinfo/"+poi.id_luogo}>Altre Risorse:</a></h3>
                      <ul>
                        {poi.bimobj.map((bimob, i) => (
                          <li > {bimob.descrizione}({bimob.categoria})</li>
                        ))}
                      </ul>
                  </div>
                  )}
            </div>
            </div>

          ))}
        </ul>
      ):(
          <iframe width="100%" height="800px" title="CIAO" src={config.external_services.reactgis}/>
      )
      )}
      <Mfooter/>
    </div>
  );
}
